export default "__VITE_ASSET__DXpEALtY__"